import { render, staticRenderFns } from "./PageAlarms.vue?vue&type=template&id=1c33a51b&scoped=true&"
import script from "./PageAlarms.vue?vue&type=script&lang=ts&"
export * from "./PageAlarms.vue?vue&type=script&lang=ts&"
import style0 from "./PageAlarms.vue?vue&type=style&index=0&id=1c33a51b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c33a51b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab})
